import { ITrimEditorManagerBase } from '../trim-editor.manager';
import { TrimUiManager } from '../ui/trim.ui.manager';

export class TrimFontManager implements ITrimEditorManagerBase {

  private static _ins: TrimFontManager;
  private fontList: string[] = [];
  private uiManager!: TrimUiManager;

  private constructor() {
  }

  static get ins() {
    if (TrimFontManager._ins) {
      return TrimFontManager._ins;
    }
    TrimFontManager._ins = new TrimFontManager();
    return TrimFontManager._ins;
  }

  di(uiManager: TrimUiManager): void {
    this.uiManager = uiManager;
  }

  initialize() {
    this.uiManager.on('t->r:font:check-support', (e) => {
      e.callback({
        supported: this.checkSupported(),
      });
    });
    this.uiManager.on('t->r:font:get-list', (e) => {
      this.getFontList()
        .then((fonts) => {
          e.callback({
            fonts,
          });
        });
    });
  }

  destroy(): void {
    this.uiManager.off('t->r:font:check-support');
    this.uiManager.off('t->r:font:get-list');
  }

  async getFontList(): Promise<string[]> {
    if (this.fontList.length) {
      return this.fontList;
    }
    const supported = this.checkSupported();
    // - check support -
    if (!supported) {
      throw new Error('ローカルフォント読み込み拡張がインストールされていません。');
    }
    // - get font list -
    const fontListDiv = document.getElementById('local-font-list') as HTMLDivElement;
    const list = JSON.parse(fontListDiv.innerHTML) as string[];
    return Promise.resolve(list);
  }

  checkSupported() {
    const fontListDiv = document.getElementById('local-font-list');
    const bool = Boolean(fontListDiv);
    return bool;
  }

}
